(() => {
const init = (scope = document) => scope.querySelectorAll('[data-wallify-review-carousel]').forEach(container => {
const source = container.querySelector('loox-dynamic-carousel-widget');
if (!source || container.dataset.initialized) return;
container.dataset.initialized = 'true';
const track = container.querySelector('.wallify-review-track');
const controls = container.querySelector('.wallify-review-controls');
const previous = controls.querySelector('[data-review-prev]');
const next = controls.querySelector('[data-review-next]');
let signature = '';
const updateButtons = () => { previous.disabled = track.scrollLeft <= 4; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3; };
const render = () => {
const root = source.shadowRoot;
if (!root) return false;
const seen = new Set();
const reviews = [...root.querySelectorAll('.text-swiper .swiper-slide')].map(slide => {
const text = slide.querySelector('.review-text')?.textContent.trim();
const name = slide.querySelector('.reviewer-name')?.textContent.trim();
const rating = Number.parseFloat(slide.querySelector('.review-rating')?.getAttribute('title'));
const verified = !!slide.querySelector('.verified-badge:not(.hidden)');
if (!text || !name || !Number.isFinite(rating)) return null;
const key = name + text;
if (seen.has(key)) return null;
seen.add(key);
return {text, name, rating, verified};
}).filter(Boolean);
if (!reviews.length) return true;
const changed = JSON.stringify(reviews);
if (changed === signature) return true;
signature = changed;
const fragment = document.createDocumentFragment();
reviews.forEach(review => {
const card = document.createElement('article');
card.className = 'wallify-review-card';
card.setAttribute('role', 'listitem');
const top = document.createElement('div');
top.className = 'wallify-review-card__top';
const stars = document.createElement('span');
stars.className = 'wallify-review-stars';
stars.setAttribute('role', 'img');
stars.setAttribute('aria-label', review.rating + ' ' + container.dataset.starLabel);
stars.textContent = '★★★★★';
const fill = document.createElement('span');
fill.setAttribute('aria-hidden', 'true');
fill.style.width = (Math.max(0, Math.min(5, review.rating)) * 20) + '%';
fill.textContent = '★★★★★';
stars.append(fill);
top.append(stars);
if (review.verified) {
const badge = document.createElement('span');
badge.className = 'wallify-review-verified';
badge.textContent = container.dataset.verified;
top.append(badge);
}
const text = document.createElement('p');
text.textContent = review.text;
const name = document.createElement('span');
name.className = 'wallify-review-card__name';
name.textContent = review.name;
card.append(top, text, name);
fragment.append(card);
});
track.replaceChildren(fragment);
track.hidden = controls.hidden = false;
track.tabIndex = 0;
container.classList.add('is-ready');
updateButtons();
return true;
};
const observe = () => {
if (!source.shadowRoot) return false;
new MutationObserver(render).observe(source.shadowRoot, {childList:true,subtree:true,characterData:true});
render();
return true;
};
if (!observe()) {
let attempts = 0;
const timer = setInterval(() => { if (observe() || ++attempts > 120) clearInterval(timer); }, 250);
}
const move = direction => track.scrollBy({left:direction * ((track.querySelector('.wallify-review-card')?.getBoundingClientRect().width || track.clientWidth) + 18), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
previous.addEventListener('click', event => { event.stopPropagation(); move(-1); });
next.addEventListener('click', event => { event.stopPropagation(); move(1); });
track.addEventListener('scroll', updateButtons, {passive:true});
new ResizeObserver(updateButtons).observe(track);
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
document.addEventListener('shopify:section:load', event => init(event.target));
document.addEventListener('wallify:deferred-ready', event => init(event.target.closest('.shopify-section') || event.target));
})();
document.addEventListener('click', event => {
const link = event.target.closest('a[href="#looxReviewsFrame"]');
const section = document.querySelector('.wallify-customer-reviews');
if (!link || !section) return;
event.preventDefault();
event.stopImmediatePropagation();
const header = document.querySelector('.section-header');
const offer = document.querySelector('.wallify-sticky-offer');
const offset = (header?.getBoundingClientRect().height || 140) + (offer?.getBoundingClientRect().height || 30) + 20;
window.scrollTo({top:window.scrollY + section.getBoundingClientRect().top - offset, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
}, true);

// Keep the photo carousel tall enough for portrait customer photos on phones.
(() => {
  const selector = 'loox-dynamic-carousel-widget:not(.wallify-loox-text)';
  const initialized = new WeakSet();
  const photoStyles = `
    @media (max-width: 749px) {
      .loox-dynamic-carousel-widget .dynamic-carousel-sliders-grid.show-review-text {
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: auto auto !important;
      }
      .loox-dynamic-carousel-widget .dynamic-carousel-image-swiper-container {
        width: 100% !important;
        min-width: 0;
        height: auto !important;
        aspect-ratio: 3 / 4;
        max-height: 640px !important;
        order: 1 !important;
      }
      .loox-dynamic-carousel-widget .dynamic-carousel-text-swiper-container { order: 2 !important; }
      .loox-dynamic-carousel-widget .image-swiper { width: 100% !important; height: 100% !important; max-height: none !important; }
      .loox-dynamic-carousel-widget .review-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  `;
  const init = (scope = document) => scope.querySelectorAll(selector).forEach(widget => {
    if (initialized.has(widget)) return;
    initialized.add(widget);
    const apply = () => {
      const root = widget.shadowRoot;
      if (!root) return false;
      if (!root.getElementById('wallify-review-photo-mobile')) {
        const style = document.createElement('style');
        style.id = 'wallify-review-photo-mobile';
        style.textContent = photoStyles;
        root.append(style);
      }
      return true;
    };
    const observe = () => {
      if (!apply()) return false;
      new MutationObserver(apply).observe(widget.shadowRoot, {childList: true});
      return true;
    };
    if (!observe()) {
      let attempts = 0;
      const timer = setInterval(() => {
        if (observe() || ++attempts >= 120) clearInterval(timer);
      }, 250);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
document.addEventListener('wallify:deferred-ready', event => init(event.target.closest('.shopify-section') || event.target));
})();

